import { DragDropService } from './drag-drop.service';
import * as i0 from "@angular/core";
export let UiDragDropModule = /*#__PURE__*/(() => {
  class UiDragDropModule {
    static {
      this.ɵfac = function UiDragDropModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiDragDropModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: UiDragDropModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [DragDropService]
      });
    }
  }
  return UiDragDropModule;
})();